module.exports = __webpack_public_path__ + "static/media/Lanyard.71fd3fac.png";